import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react'
import TempForm from '../TempForm'; 
function CompleteForm({form, close, state, patient}){

    // `submittedByGuardianPid` used to be set here, from client state. The
    // server derives it now, from the verified session and the guardianship in
    // force - a browser naming the guardian is the party being authorised
    // vouching for its own authority, and the field is discarded on arrival.

    // WHOSE form this is, which is not always the person signed in. A guardian
    // filling in a dependent's form passes the dependent's record - already
    // redacted server-side by their field scope, so a guardian who may not see
    // an address does not get handed it inside a prefilled field. Defaulting to
    // `state.patient` keeps the account holder's own forms unchanged: the
    // account holder never moves.
    const subject = patient || state?.patient;

    const defaultData = {
        db: state.organization.db,
        formData: form,
        patient: subject,
        location: state.locations.find(e => e.lid === state.selectedLocation),
        bucketName: state.organization?.s3BucketName,
        state: state,
    }
    return (
        <Modal isOpen={true}  isCentered onClose={()=>close()} size="4xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent  minH="90vh" minW="80vw"  display="flex"  flexDirection="column" >
        
          <ModalCloseButton />
          <ModalHeader textAlign="center" color="gray.500"  mt="0" className="text-lg font-semibold">   {form?.formTitle} </ModalHeader>
          
          <ModalBody  mt="0"  display="flex" flex="1" flexDirection="column"    py="4">
          <TempForm defaultData={defaultData}  action={close} />
        
    
          </ModalBody>
    
     
     
        </ModalContent>
        </Modal>
      )
}

export default CompleteForm;
